// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import TableauDeBord from '@/TableauDeBord.vue';
import HomePage from '../HomePage.vue'; // Importez la page d'accueil
import LoginPage from '../LoginPage.vue'; // Importez la page de connexion
import AddLocation from '../AddLocation.vue';
import AboutPage from '../AboutPage.vue';
import AddArticle from '../AddArticle.vue';
import ModifyArticle from '../ModifyArticle.vue';
import PermissionPage from '../PermissionPage.vue';
import AdminPage from '../AdminPage.vue';
import MonCompte from '../MonCompte.vue';
import ListeUtilisateur from '../ListeUtilisateur.vue';
import InsriptionPage from '../InscriptionPage.vue';
import InventairePage from '@/InventairePage.vue';
const routes = [
  {
    path: '/home',
    name: 'Home',
    component: HomePage,  // Composant de la page d'accueil
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,  // Composant de la page de connexion
  },

  {
    path: '/about-page',
    name: 'AboutPage',
    component: AboutPage,  // Composant de la page de connexion
  },

  {
    path: '/permission-page',
    name: 'PermissionPage',
    component: PermissionPage,  // Composant de la page de connexion
  },

  {
    path: '/admin-page',
    name: 'AdminPage',
    component: AdminPage,  // Composant de la page de connexion
  },

  {
    path: '/add-article',
    name: 'AddArticle',
    component: AddArticle,  // Composant de la page de connexion
  },

  {
    path: '/modify-article',
    name: 'ModifyArticle',
    component: ModifyArticle,  // Composant de la page de connexion
  },


  {
    path: '/mon_compte',
    name: 'MonCompte',
    component: MonCompte,  // Composant de la page de connexion
  },

  {
    path: '/liste_utlisateur',
    name: 'ListeUtilisateur',
    component: ListeUtilisateur,  // Composant de la page de connexion
  },

  {
    path: '/inscriptionPage',
    name: 'InscriptionPage',
    component: InsriptionPage,  // Composant de la page de connexion
  },

  {
    path: '/tableauDeBord',
    name: 'TableauDeBord',
    component: TableauDeBord,  // Composant de la page de connexion
  },



  {
    path: '/inventairePage',
    name: 'InventairePage',
    component: InventairePage,  // Composant de la page de connexion
  },

  

  {
    path: '/',  // Redirection de la route racine
    redirect: '/login',  // Redirige vers /login par défaut
  },
  {
    path: '/:pathMatch(.*)*',  // Route pour les chemins non trouvés (404)
    redirect: '/login',  // Redirige vers /login en cas de route non trouvée
  },
  {
    path: '/add-location',
    name: 'AddLocation',
    component: AddLocation
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
